const English = {
    VIDEO_ACQUIRING_LICENSE: 'Acquiring license..',
    VIDEO_BUFFERING: 'Buffering...',
    VIDEO_ACQUIRING_MANIFEST: 'Retrieving manifest..',
    INITIALIZING: 'Initializing',
    NONE: 'None',
};


export default English;



// WEBPACK FOOTER //
// ./src/js/localization/default-en.js